import { getHttpService } from "../services/http.service";
import {
  CommitPendingBooking,
  PendingBookingAddMenuEndpoint,
  PendingBookingValidateGiftCodeEndpoint,
  PendingBookingRemoveVoucher,
  PendingBookingEndpoint,
  PendingBookingRemoveMenuEndpoint,
  UpdatePendingBookingEndpoint,
  UpdatePendingBookingFromBookingEndPoint,
  PendingBookingAddOfferEndpoint,
  PendingBookingRemoveOfferEndpoint,
  PendingBookingPaymentConfirmed,
} from "../endpoints/PendingBooking";
import { PendingBookingContact } from "../types";
import { Observable } from "rxjs";
import { pendingBookingStore } from "../stores/pending-booking.store";
import { getCreatePendingBookingService } from "../services/create-pending-booking.service";
import { requestParamsImpl } from "../services/request-params.service";

const httpService = getHttpService();

export const createInitialPendingBookingRequest = (): Observable<any> => {
  let endpoint = null;
  const { bookingId, bookingToken } = requestParamsImpl.requestParams;
  const pendingBooking =
    getCreatePendingBookingService().createInitialPendingBooking();
  pendingBooking.booking_token = bookingToken;
  if (bookingId && bookingToken) {
    endpoint = new UpdatePendingBookingFromBookingEndPoint(bookingId);
  } else {
    endpoint = new PendingBookingEndpoint();
  }
  return httpService.post(endpoint, pendingBooking);
};

export const updatePendingBookingRequest = (data: {
  contact_info?: PendingBookingContact;
  selected_offer?: number | null;
  stripe_token?: string | null;
}): Observable<any> => {
  const id = pendingBookingStore.pendingBooking.id;
  const endpoint = new UpdatePendingBookingEndpoint(id);
  return httpService.put(endpoint, data);
};

export const getPendingBookingRequest = (id: string): Observable<any> => {
  const endpoint = new UpdatePendingBookingEndpoint(id!);
  return httpService.put(endpoint, {});
};

export const cancelPendingBookingRequest = (id?: string): Observable<any> => {
  const _id = pendingBookingStore.pendingBooking.id || id;
  const endpoint = new UpdatePendingBookingEndpoint(_id!);
  return httpService.delete(endpoint, {});
};

export const checkVoucherCode = (gift_code: string): Observable<any> => {
  const id = pendingBookingStore.pendingBooking.id;
  const endpoint = new PendingBookingValidateGiftCodeEndpoint(id);
  const voucher_infos = { gift_code };
  return httpService.put(endpoint, voucher_infos);
};

export const removeVoucherCodeToPendingBooking = (
  gift_code: string
): Observable<any> => {
  const id = pendingBookingStore.pendingBooking.id;
  const endpoint = new PendingBookingRemoveVoucher(id);
  return httpService.delete(endpoint, { code: gift_code });
};

export const removeOfferToPendingBooking = (
  offer_id: number
): Observable<any> => {
  const id = pendingBookingStore.pendingBooking.id;
  const endpoint = new PendingBookingRemoveOfferEndpoint(id);
  return httpService.delete(endpoint, { offer_id });
};

export const addOfferToPendingBooking = (offer_id: number): Observable<any> => {
  const id = pendingBookingStore.pendingBooking.id;
  const endpoint = new PendingBookingAddOfferEndpoint(id);
  return httpService.put(endpoint, { offer_id });
};

export const addMenuToPendingBooking = (
  menu_id: number,
  quantity?: number
): Observable<any> => {
  const id = pendingBookingStore.pendingBooking.id;
  const endpoint = new PendingBookingAddMenuEndpoint(id);
  if (quantity != undefined) {
    return httpService.put(endpoint, { menu_id, quantity });
  }
  return httpService.put(endpoint, { menu_id });
};

export const removeMenuFromPendingBooking = (
  menu_id: number
): Observable<any> => {
  const id = pendingBookingStore.pendingBooking.id;
  const endpoint = new PendingBookingRemoveMenuEndpoint(id);
  return httpService.delete(endpoint, { menu_id });
};

export const getPaymentConfirmed = (
  pending_booking_id: string
): Observable<any> => {
  const endpoint = new PendingBookingPaymentConfirmed(pending_booking_id);
  return httpService.put(endpoint, {});
};

export const commitPendingBooking = (data: {
  stripe_token?: string;
  pending_booking_id?: string;
}): Observable<any> => {
  const id = data.pending_booking_id
    ? data.pending_booking_id
    : pendingBookingStore.pendingBooking.id;
  const recaptchaValue = pendingBookingStore.pendingBooking.recaptchaValue;
  const stripe_token = data.stripe_token;
  const endpoint = new CommitPendingBooking(id);
  return httpService.put(endpoint, { stripe_token, recaptchaValue });
};
